var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"initials",style:(_vm.avatarStyle)},[(!_vm.avatar)?_c('span',[_vm._v(_vm._s(_vm.initials))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }